module.exports = __webpack_public_path__ + "static/media/14.27304d93.jpg";